import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDefaultAddressDialogData } from '@x/ecommerce-shop/app/core/auth/services/user-address-dialog.service';
import { ShopDialogUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-dialog-ui/shop-dialog-ui.module';
import { SubscriberPillsComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/subscriber-pills/subscriber-pills.component';

@Component({
  selector: 'x-set-default-address-dialog',
  imports: [
    ShopDialogUiModule,
    MatButtonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    SubscriberPillsComponent,
  ],
  templateUrl: './set-default-address-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetDefaultAddressDialogComponent {
  readonly dialogRef = inject(MatDialogRef<SetDefaultAddressDialogComponent>);
  data = inject<IDefaultAddressDialogData>(MAT_DIALOG_DATA);
  subscriberControls = new Map<number, FormControl<boolean>>();

  constructor() {
    // Initialize controls for all subscribers with checked state
    this.data.subscribers?.forEach((subscriber) => {
      this.subscriberControls.set(subscriber.id, new FormControl(true, { nonNullable: true }));
    });
  }

  getSubscriberControl(subscriberId: number): FormControl<boolean> {
    return (
      this.subscriberControls.get(subscriberId) || new FormControl(false, { nonNullable: true })
    );
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    const selectedSubscriberIds: number[] = [];

    this.subscriberControls.forEach((control, subscriberId) => {
      if (control.value) {
        selectedSubscriberIds.push(subscriberId);
      }
    });

    this.dialogRef.close(selectedSubscriberIds);
  }
}
